import dayjs from 'dayjs'

export const getDateRangeFromCart = cart => {
  let startDate = null
  let endDate = null
  const items = cart?.items || {}

  const allItems = Object.values(items).flat()
  allItems.forEach(item => {
    if (
      item.startDate &&
      (!startDate || dayjs(item.startDate).isBefore(startDate))
    ) {
      startDate = dayjs(item.startDate).format('YYYY-MM-DD')
    }
    if (item.endDate && (!endDate || dayjs(item.endDate).isAfter(endDate))) {
      endDate = dayjs(item.endDate).format('YYYY-MM-DD')
    }
  })

  return {
    startDate,
    endDate,
  }
}

export const openWindowWithPost = (url, data) => {
  const form = document.createElement('form')
  form.method = 'POST'
  form.action = url
  form.style.display = 'none'
  data.forEach(param => {
    const input = document.createElement('input')
    input.type = 'hidden'
    input.name = param.key
    input.value = param.value
    form.appendChild(input)
  })
  document.body.appendChild(form)
  form.submit()
  document.body.removeChild(form)
}

export const getEarliestDateTimeFromCart = cart => {
  const dates =
    cart?.items?.hotels?.map(hotel =>
      dayjs.tz(hotel.startDate).toDate().getTime(),
    ) || []

  const ferryDepartureDate =
    cart?.items?.ferries?.[0]?.crossings?.[0]?.departureDate
  const ferryDepartureTime =
    cart?.items?.ferries?.[0]?.crossings?.[0]?.departureTime

  if (ferryDepartureDate && ferryDepartureTime) {
    dates.push(
      dayjs
        .tz(ferryDepartureDate)
        .set('hour', ferryDepartureTime.split(':')[0])
        .set('minutes', ferryDepartureTime.split(':')[1])
        .toDate()
        .getTime(),
    )
  }

  return dates.length ? dayjs(Math.min(...dates)) : null
}

export const getFerryDatesFromCart = cart => {
  const ferryItem = cart?.items?.ferries?.[0]
  if (!ferryItem) {
    return null
  }

  const departureDateTime = ferryItem?.crossings?.[0]?.departureDateTime
  const returnDateTime =
    ferryItem?.crossings?.[1]?.departureDateTime ||
    ferryItem?.crossings?.[0]?.arrivalDateTime
  return {
    start: departureDateTime,
    end: returnDateTime,
    isReturnTrip:
      ferryItem?.crossings?.length && ferryItem.crossings.length > 1,
  }
}

export const getAccommodationDatesFromCart = cart => {
  const hotels = cart?.items?.hotels
  if (!hotels?.length) {
    return null
  }

  return hotels.reduce(
    (obj, hotel) => {
      const current = {
        ...obj,
      }
      if (
        hotel.startDate &&
        (!current.start ||
          dayjs(hotel.startDate).isBefore(dayjs(current.start), 'days'))
      ) {
        current.start = hotel.startDate
      }

      if (
        hotel.endDate &&
        (!current.end ||
          dayjs(hotel.endDate).isAfter(dayjs(current.end), 'days'))
      ) {
        current.end = hotel.endDate
      }

      return current
    },
    {
      start: null,
      end: null,
    },
  )
}

export const getHotelGuestCountsFromCart = cart => {
  const hotels = cart?.items?.hotels
  if (!hotels?.length) {
    return null
  }

  return hotels.reduce(
    (arr, hotel) => [
      ...arr,
      {
        adults: hotel.adults,
        children: hotel.children,
      },
    ],
    [],
  )
}
